import React, { useContext } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { AuthContext } from '../context/AuthContext';

const PublicRouteShell = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

const PublicRouteMain = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  
`;

/**
 * PublicRoute component
 * Prevents authenticated users from accessing public routes (e.g., login page)
 * Redirects them to the dashboard if they're already logged in
 */
const isElectronApp = () =>
  typeof window !== 'undefined' && !!window.electronAPI?.isElectron;

const PublicRoute = () => {
  const { currentUser, isLoading } = useContext(AuthContext);
  const location = useLocation();

  // Only redirect once the auth check is complete and we know the user is logged in.
  // Do NOT show a separate spinner — swapping between a bare spinner DOM and the
  // full layout DOM is what causes the sign-in page to flicker on every load.
  if (!isLoading && currentUser) {
    // Desktop POS: signed-in users go straight to the POS screen.
    // Users without a branch (e.g. owners) still land on the dashboard to pick one.
    if (isElectronApp()) {
      const posPath = currentUser.branchId ? `/pos/${currentUser.branchId}` : '/dashboard';
      return <Navigate to={posPath} replace />;
    }
    const redirectPath = location.state?.from?.pathname || '/dashboard';
    return <Navigate to={redirectPath} replace />;
  }

  // Desktop POS: full-screen sign-in only (no marketing chrome).
  if (isElectronApp()) {
    return <Outlet />;
  }

  return (
    <PublicRouteShell>
      <PublicRouteMain>
        <Outlet />
      </PublicRouteMain>
    </PublicRouteShell>
  );
};

export default PublicRoute;